export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PurchaseOrderCard.vue?vue&type=template&id=5572379e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/InputFromPurchaseOrder/PurchaseOrderCard.vue?vue&type=template&id=5572379e&scoped=true
// module id = 2389
// module chunks = 31